import { render, staticRenderFns } from "./PersonCommentIcon.vue?vue&type=template&id=6d52ce38&"
import script from "./PersonCommentIcon.vue?vue&type=script&lang=ts&"
export * from "./PersonCommentIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports